<template>
<div id="app" class="d-flex h-100 flex-column scrollable">
  <!-- nav bar -->
  <div class="container-fullwidth">
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand href="/">NEURON</b-navbar-brand>
      <b-navbar-nav v-if="this.$route.path === '/'" class="ml-auto">
        <b-nav-item href="#" active v-on:click="changeDb()">Switch DB</b-nav-item>
        <!-- b-nav-item href="https://www.notion.so/NEURON-Help-Document-f479e4cf6aa249689402392a8c0524d0" active target="_blank">Help</b-nav-item -->
        <b-nav-item-dropdown text="Menu" right>
            <b-dropdown-item href="/#/about">About</b-dropdown-item>
            <!-- b-dropdown-item href="/#/overview">System Overview</b-dropdown-item -->
            <b-dropdown-item href="/#/datasets">Datasets</b-dropdown-item>
            <b-dropdown-item href="/#/userguide">User Guide</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
  </div>
  <!-- router -->
  <router-view></router-view>
</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'app',
  data: function() {
    return {
      showOverlay: false
    }
  },
  created() {
    // goto login page by default, if user logged in already, go to main page
    if (localStorage.db) {
      // load the db from local storage to vuex store (to make it reactive)
      this.setDb(localStorage.db)
      this.setEmail(localStorage.email)
      this.$router.replace("/", () => {})
    } else {
      this.$router.replace("/login", () => {})
    }
  },
  computed: {
    ...mapState([
      'db'
    ])
  },
  watch: {
    db(newVal, oldVal) {
      this.$bvToast.toast("Switched to " + newVal.toUpperCase() + " database", {
        title: `Database changed`,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        appendToast: true,
        autoHideDelay: 2000
      })
    }
  },
  methods: {
    changeDb() {
      let currDb = this.db
      if (currDb === "tpch") {
        this.setDb("imdb")
      } else if (currDb === "imdb") {
        this.setDb("tpch")
      }
    },
    ...mapActions([
      'setDb'
    ]),
    ...mapMutations([
      'setEmail'
    ])
  }
}
</script>
